import { useTranslation } from 'react-i18next'
import ToggleDescriptionField from '../ToggleDescriptionField'

const ProfileDiscovery = ({ condensed }) => {
  const { t } = useTranslation()

  const title = t('r.settings.view.allow_profile_discovery.label', 'Allow Discovery')

  const description = t(
    'r.settings.view.profile_discovery.label',
    'By enabling Discovery, landlords will be able to see your profile and match with you.'
  )
  return (
    <ToggleDescriptionField
      condensed={condensed}
      title={title}
      description={description}
      fieldName="allow_discovery"
    />
  )
}

export default ProfileDiscovery
